/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontAboutSection_seller = {
    readonly storefrontProfile: {
        readonly aboutUs: string | null;
        readonly logo: {
            readonly path: string | null;
        } | null;
    } | null;
    readonly sellerProfile: {
        readonly company: string | null;
    } | null;
    readonly sellerPreferences: {
        readonly scrollLogoLg: string | null;
        readonly displayStoreAddress: boolean | null;
        readonly storeAddressByAppointmentOnly: boolean | null;
    } | null;
    readonly tradeAssociations: ReadonlyArray<{
        readonly displayName: string | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontContactModal_seller">;
    readonly " $refType": "StorefrontAboutSection_seller";
};
export type StorefrontAboutSection_seller$data = StorefrontAboutSection_seller;
export type StorefrontAboutSection_seller$key = {
    readonly " $data"?: StorefrontAboutSection_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontAboutSection_seller">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontAboutSection_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "storefrontId",
      "type": "Int"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "storefrontProfile",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "storefrontId",
          "variableName": "storefrontId"
        }
      ],
      "concreteType": "StorefrontProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "aboutUs",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "logo",
          "storageKey": null,
          "args": null,
          "concreteType": "Photo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "path",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sellerProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "SellerProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "company",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sellerPreferences",
      "storageKey": null,
      "args": null,
      "concreteType": "SellerPreferences",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "scrollLogoLg",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayStoreAddress",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "storeAddressByAppointmentOnly",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "tradeAssociations",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeAssociation",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayName",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontContactModal_seller",
      "args": null
    }
  ]
};
(node as any).hash = '38bb5cad47d13d5d2d27ab20fe35b7ec';
export default node;
